import React from 'react';
import $ from 'jquery';
import SupplierService from '../services/supplier';
import NumberFormat from 'react-number-format';
import Modal from 'react-bootstrap/Modal';
import CountryService from '../services/country';
import AuthorizationCheck from '../auth/authorizationCheck';
import Utility from '../utilities/utility';
import BranchService from '../services/branch';

class Branches extends React.Component {

    constructor(props) {
        super(props);
        this.countryService = new CountryService();
        this.branchService = new BranchService();
        this.state = {

            countries: [],
            currentUserRole: '',
            showModal: false,
            showCreateBranchModal: false,
            branches: [],
            timeoutId: null,
        };
    }

    componentDidMount() {


        this.fetchCountries();

    }

    searchBranch = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.branchList();
        }, 1500);

        this.setState({ timeoutId: timer })
    }



    create = async () => {

        let name = $('#branchName').val();

        let countryId = $('#countryId').val();

        if (Utility.isEmpty(name) || Utility.isEmpty(countryId)) {

            $('.messageHolder').html(
                '<div class="alert alert-danger message-alert">Des données obligatoires non entreees</div>'
            )
            $('.message-alert').delay(3000).fadeOut('fast');

            return;
        }

        try {

            const response = await this.branchService.createBranch(countryId, name);

            if (response.ok) {

                const branchData = await response.json();

                let branches = [...this.state.branches];

                branches.unshift(branchData);
                this.setState({ branches: branches });

                $('.messageHolder').html(
                    '<div class="alert alert-success message-alert">Branche Crée</div>'
                )
                $('.message-alert').delay(3000).fadeOut('fast');

            } else {

                $('.messageHolder').html(
                    '<div class="alert alert-success message-alert">Branche non crée</div>'
                )
                $('.message-alert').delay(3000).fadeOut('fast');
            }




        } catch (error) {

            $('.messageHolder').html(
                '<div class="alert alert-success message-alert">Branche non crée</div>'
            )
            $('.message-alert').delay(3000).fadeOut('fast');
        }





    }



    handleCloseModal = () => {

        this.setState({ showModal: false })
    }

    handleCloseCreateBranchModal = () => {

        this.setState({ showCreateBranchModal: false })
    }

    showCreateBranchModal = () => {

        this.setState({ showCreateBranchModal: true })
    }


    fetchCountries = async () => {

        try {

            const response = await this.countryService.fetchCountries();

            this.setState({
                countries: await response.json()
            });

        } catch (error) {
            console.log(error)
        }

    }



    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    branchList = async () => {

        try {

            let countryId = $('#selectedCountryId').val();

            if(Utility.isEmpty(countryId)){

                Utility.showAlertWithId('errorHolder', 'Veillez choisir le pays', 'danger', true);

                return;
            }
            let name = $('#searchName').val();

            const response = await this.branchService.branchList(countryId, name);

            this.setState({

                branches: await response.json()
            });
        } catch (error) {

            console.log(error);
        }


    }



    render() {



        const branches = this.state.branches;

        const rightBtn = {
            width: 200,
            marginLeft: '80%'
        }

        return (


            <div className="container">



                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />


                <h2>Branches</h2>

                <Modal show={this.state.showCreateBranchModal}>
                    <Modal.Header closeButton onHide={this.handleCloseCreateBranchModal}>Nouvelle Branche</Modal.Header>
                    <Modal.Body>
                        <div className='container'>
                            <div className="messageHolder"></div>



                            <div className="form-group row">

                                <input type="text" className="form-control" id="branchName" placeholder="Nom de la branche" />

                            </div>




                            <div className="form-group row">
                                <label className="label">Pays</label>
                                <select className="form-control full-width" id="countryId">
                                    <option></option>
                                    {this.state.countries.length > 0 && this.state.countries.map(country =>



                                        <option key={country.countryId} value={country.countryId}>{country.name}</option>

                                    )}
                                </select>

                            </div>


                            <div className="form-group row">
                                <button className="btn btn-primary" onClick={this.create}>Create</button>
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>


                    </Modal.Footer>
                </Modal>


                <button className='btn btn-primary mt-4' style={rightBtn} onClick={this.showCreateBranchModal}>Nouvelle Branche</button>

                <div className='form-wrapper'>

                    <div id='errorHolder'></div>

                    <div className="form-group row">
                        <label className="label">Pays</label>
                        <select className="form-control full-width" id="selectedCountryId" onChange={this.branchList}>
                            <option></option>
                            {this.state.countries.length > 0 && this.state.countries.map(country =>



                                <option key={country.countryId} value={country.countryId}>{country.name}</option>

                            )}
                        </select>

                    </div>

                    <div className="form-group row">

                        <input type="text" className="form-control" id="searchName" onKeyUp={this.searchBranch} placeholder="Veillez entrer le nom de la branche" />

                    </div>

                </div>




                <div className="branch-wrapper mt-4">

                    {branches.length > 0 && branches.map(branch =>

                        <div className="card card-default mt-2" key={branch.branchId}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col">{branch.name}</div>

                                    <div className="col"><a href={'/manager/branch/update?branchId=' + branch.branchId}>Modifier</a></div>



                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>



        );


    }

}

export default Branches;